import React from 'react';
import MapWorld from '../components/MapWorld/MapWorld';
import { useAuth } from '../contexts/AuthContext';

import { AlertCircle } from 'lucide-react';
import BackButton from '../components/BackButton';

const AdminMapWorld = () => {
  const { user, getAuthHeader } = useAuth();
  
  // Vérifier les permissions
  if (!user || user.role !== 'super_admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        
      {/* Bouton Retour */}
      <BackButton to="/admin/dashboard" label="Retour" />

<div className="bg-white p-8 rounded-lg shadow-lg max-w-md text-center">
          <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold mb-2 text-gray-900">Accès Refusé</h2>
          <p className="text-gray-600 mb-4">
            Cette page est réservée au super administrateur.
          </p>
          <button
            onClick={() => window.history.back()}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
          >
            Retour
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="admin-map-world">
      <MapWorld isAdminView={true} getAuthHeader={getAuthHeader} />
    </div>
  );
};

export default AdminMapWorld;
